import React, { Component } from "react";
import "./css/Section.css";

export default class Section extends Component {
  render() {
    return (
      <div className="section" style={this.props.style}>
        <div className="section-container">
          {this.props.divider ? (
            <img
              draggable={false}
              className="section-divider"
              alt="divider"
              src={this.props.divider.image}
            />
          ) : null}
          {this.props.image ? (
            <img
              draggable={false}
              alt="section"
              className="section-background-image"
              style={this.props.imageStyle}
              src={this.props.image}
            />
          ) : null}

          {this.props.children}
        </div>
      </div>
    );
  }
}
